var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDataCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.96667 7.03333V0.5C12.5787 0.5 15.5 3.42133 15.5 7.03333H8.96667ZM7.03333 2.43333V8.96667H13.5667C13.5667 12.5787 10.6453 15.5 7.03333 15.5C3.42133 15.5 0.5 12.5787 0.5 8.96667C0.5 5.35467 3.42133 2.43333 7.03333 2.43333Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDataCircle);
export default __webpack_public_path__ + "static/media/icon-data-circle.31bf124c7be60b570ead2199276455ea.svg";
export { ForwardRef as ReactComponent };